import React, { FC, useEffect, useMemo, useRef, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { PageTitle } from '../../../_metronic/layout/core'
import AutoComplete from '../components/AddressAutoComplete'
import GoogleMapComponent2 from '../components/GoogleMapComponent2'
import {
  fetchData,
  getEncryptedRoute,
  handleTimeChange,
  toasterrormsg,
  toastsuccessmsg,
  useMenuIdPermissions,
} from '../../../reusable'
import { ToastContainer } from 'react-toastify'
import { AddCarRentalHeader } from './AddCarRentalHeader'
import PhoneInput from 'react-phone-input-2'
import moment from 'moment'
import Flatpickr from 'react-flatpickr'
import { Tr } from '../../../_metronic/i18n/Tr'

const AddCarRentalPickupOrDropoffInfo: FC = () => {
  let t = Tr()
  const { menuId } = useMenuIdPermissions()

  const location = useLocation()
  const editCarrentalId = (location.state as any)?.carrentalId || ''

  var vendorId = ''
  const vendorData = sessionStorage.getItem('vendor')
  if (vendorData) {
    var vendor = JSON.parse(vendorData)
    vendorId = vendor.vendorId
  } else {
  }
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [disable, setDisable] = useState(false)
  const primaryLanguage = sessionStorage.getItem('primaryLanguage')
  const [carRentalDetails, setCarRentalDetails] = useState([])
  const [pickUpBranchNameEN, setPickUpBranchNameEN] = useState('')
  const [pickUpBranchNameRU, setPickUpBranchNameRU] = useState('')
  const [pickUpBranchNameUZ, setPickUpBranchNameUZ] = useState('')
  const [pickUpBranchCountry, setPickUpBranchCountry] = useState('')
  const [pickUpBranchState, setPickUpBranchState] = useState('')
  const [pickUpBranchCity, setPickUpBranchCity] = useState('')
  const [pickUpBranchAddress, setPickUpBranchAddress] = useState('')
  const [pickUpBranchLongitude, setPickUpBranchLongitude] = useState('')
  const [pickUpBranchLatitude, setPickUpBranchLatitude] = useState('')
  const [pickUpCountryCode, setPickUpCountryCode] = useState('')
  const [pickUpContactNumber, setPickUpContactNumber] = useState('')
  const [pickUpGettingThereEN, setPickUpGettingThereEN] = useState('')
  const [pickUpGettingThereRU, setPickUpGettingThereRU] = useState('')
  const [pickUpGettingThereUZ, setPickUpGettingThereUZ] = useState('')
  const [pickUpInstructionEN, setPickUpInstructionEN] = useState('')
  const [pickUpInstructionRU, setPickUpInstructionRU] = useState('')
  const [pickUpInstructionUZ, setPickUpInstructionUZ] = useState('')
  const [pickupLocationObj, setPickUpLocationObj] = useState(null) as any

  const [dropOffBranchNameEN, setDropOffBranchNameEN] = useState('')
  const [dropOffBranchNameRU, setDropOffBranchNameRU] = useState('')
  const [dropOffBranchNameUZ, setDropOffBranchNameUZ] = useState('')
  const [dropOffBranchCountry, setDropOffBranchCountry] = useState('')
  const [dropOffBranchState, setDropOffBranchState] = useState('')
  const [dropOffBranchCity, setDropOffBranchCity] = useState('')
  const [dropOffBranchAddress, setDropOffBranchAddress] = useState('')
  const [dropOffBranchLongitude, setDropOffBranchLongitude] = useState('')
  const [dropOffBranchLatitude, setDropOffBranchLatitude] = useState('')
  const [dropOffCountryCode, setDropOffCountryCode] = useState('')
  const [dropOffContactNumber, setDropOffContactNumber] = useState('')
  const [dropOffGettingThereEN, setDropOffGettingThereEN] = useState('')
  const [dropOffGettingThereRU, setDropOffGettingThereRU] = useState('')
  const [dropOffGettingThereUZ, setDropOffGettingThereUZ] = useState('')
  const [dropOffInstructionEN, setDropOffInstructionEN] = useState('')
  const [dropOffInstructionRU, setDropOffInstructionRU] = useState('')
  const [dropOffInstructionUZ, setDropOffInstructionUZ] = useState('')
  const [dropOffLocationObj, setDropOffLocationObj] = useState(null) as any

  useEffect(() => {
    if (pickupLocationObj) {
      setPickUpBranchCountry(pickupLocationObj.country)
      setPickUpBranchState(pickupLocationObj.state)
      setPickUpBranchCity(pickupLocationObj.city)
      setPickUpBranchAddress(pickupLocationObj.location)
      setPickUpBranchLatitude(pickupLocationObj.latitude)
      setPickUpBranchLongitude(pickupLocationObj.longitude)
    }
  }, [pickupLocationObj])
  useEffect(() => {
    if (dropOffLocationObj) {
      setDropOffBranchCountry(dropOffLocationObj.country)
      setDropOffBranchState(dropOffLocationObj.state)
      setDropOffBranchCity(dropOffLocationObj.city)
      setDropOffBranchAddress(dropOffLocationObj.location)
      setDropOffBranchLatitude(dropOffLocationObj.latitude)
      setDropOffBranchLongitude(dropOffLocationObj.longitude)
    }
  }, [dropOffLocationObj])

  // const [pickupOpeningHourData, setPickupOpeningHourData] = useState([
  //     { day: 'MONDAY', timeSlot: [{ startTime: '', endTime: '' }] },
  //     { day: 'TUESDAY', timeSlot: [{ startTime: '', endTime: '' }] },
  //     { day: 'WEDNESDAY', timeSlot: [{ startTime: '', endTime: '' }] },
  //     { day: 'THURSDAY', timeSlot: [{ startTime: '', endTime: '' }] },
  //     { day: 'FRIDAY', timeSlot: [{ startTime: '', endTime: '' }] },
  //     { day: 'SATURDAY', timeSlot: [{ startTime: '', endTime: '' }] },
  //     { day: 'SUNDAY', timeSlot: [{ startTime: '', endTime: '' }] }
  // ]);

  const [pickupOpeningHourData, setPickupOpeningHourData] = useState([
    { day: 'MONDAY', isOpen: '0', timeSlot: [{ startTime: '00:00:00', endTime: '00:00:00' }] },
    { day: 'TUESDAY', isOpen: '0', timeSlot: [{ startTime: '00:00:00', endTime: '00:00:00' }] },
    { day: 'WEDNESDAY', isOpen: '0', timeSlot: [{ startTime: '00:00:00', endTime: '00:00:00' }] },
    { day: 'THURSDAY', isOpen: '0', timeSlot: [{ startTime: '00:00:00', endTime: '00:00:00' }] },
    { day: 'FRIDAY', isOpen: '0', timeSlot: [{ startTime: '00:00:00', endTime: '00:00:00' }] },
    { day: 'SATURDAY', isOpen: '0', timeSlot: [{ startTime: '00:00:00', endTime: '00:00:00' }] },
    { day: 'SUNDAY', isOpen: '0', timeSlot: [{ startTime: '00:00:00', endTime: '00:00:00' }] },
  ])

  // const addPickupTimeField = (index: any) => {
  //     const newData = [...pickupOpeningHourData];
  //     newData[index].timeSlot.push({ startTime: '', endTime: '' });
  //     setPickupOpeningHourData(newData);
  // };

  const addPickupTimeField = (index: any) => {
    const newData = [...pickupOpeningHourData]

    // If currently closed (no time slots), set isOpen to '1'
    if (newData[index].timeSlot.length === 0) {
      newData[index].isOpen = '1'
    }

    newData[index].timeSlot.push({ startTime: '00:00:00', endTime: '00:00:00' })
    setPickupOpeningHourData(newData)
  }
  const removePickUpTimeField = (dayIndex: any, timeIndex: any) => {
    setPickupOpeningHourData((prev: any) => {
      const newData = [...prev]
      newData[dayIndex].timeSlot.splice(timeIndex, 1)

      // If no time slots left, set isOpen to '0'
      if (newData[dayIndex].timeSlot.length == 0) {
        newData[dayIndex].isOpen = '0'
      }

      return newData
    })
  }

  const handlePickupInputChange = (dayIndex: any, timeIndex: any, event: any) => {
    const { name, value } = event.target
    const parsedTime = moment(value, 'HH:mm')
    // Format the time as HH:mm:ss
    let formattedValue = parsedTime.isValid() ? parsedTime.format('HH:mm:ss') : ''
    const newData = [...pickupOpeningHourData] as any
    // Validate start time against end time
    if (name === 'startTime') {
      const endTime = newData[dayIndex].timeSlot[timeIndex].endTime
      if (endTime && formattedValue >= endTime) {
        // Handle validation error (e.g., display error message)
        toasterrormsg('End Time Must be Greater Than Start Time')
        return // Do not update state if validation fails
      }
    } else if (name === 'endTime') {
      const startTime = newData[dayIndex].timeSlot[timeIndex].startTime
      // If endTime is entered as 00:00, replace with 23:45
      if (formattedValue === '00:00:00') {
        formattedValue = '23:45:00'
      }

      if (startTime && formattedValue <= startTime) {
        // Handle validation error (e.g., display error message)
        toasterrormsg('End Time Must be Greater Than Start Time')
        return // Do not update state if validation fails
      }
    }
    // Validate time conflicts
    for (let i = 0; i < newData[dayIndex].timeSlot.length; i++) {
      if (i !== timeIndex) {
        const existingStartTime = newData[dayIndex].timeSlot[i].startTime
        const existingEndTime = newData[dayIndex].timeSlot[i].endTime
        if (
          (formattedValue >= existingStartTime && formattedValue < existingEndTime) ||
          (existingStartTime >= formattedValue && existingStartTime < formattedValue)
        ) {
          toasterrormsg('Time Is Conflict')
          return
        }
      }
    }
    newData[dayIndex].timeSlot[timeIndex][name] = formattedValue
    setPickupOpeningHourData(newData)
  }

  // Check if any required fields are not defined or empty
  const isPickupOpeningHoursValid = pickupOpeningHourData.every((opening) => {
    return opening.day && opening.timeSlot.every((slot) => slot.startTime && slot.endTime)
  })

  // const [dropOffOpeningHourData, setDropOffOpeningHourData] = useState([
  //     { day: 'MONDAY', timeSlot: [{ startTime: '', endTime: '' }] },
  //     { day: 'TUESDAY', timeSlot: [{ startTime: '', endTime: '' }] },
  //     { day: 'WEDNESDAY', timeSlot: [{ startTime: '', endTime: '' }] },
  //     { day: 'THURSDAY', timeSlot: [{ startTime: '', endTime: '' }] },
  //     { day: 'FRIDAY', timeSlot: [{ startTime: '', endTime: '' }] },
  //     { day: 'SATURDAY', timeSlot: [{ startTime: '', endTime: '' }] },
  //     { day: 'SUNDAY', timeSlot: [{ startTime: '', endTime: '' }] }
  // ]);
  const [dropOffOpeningHourData, setDropOffOpeningHourData] = useState([
    { day: 'MONDAY', isOpen: '0', timeSlot: [{ startTime: '00:00:00', endTime: '00:00:00' }] },
    { day: 'TUESDAY', isOpen: '0', timeSlot: [{ startTime: '00:00:00', endTime: '00:00:00' }] },
    { day: 'WEDNESDAY', isOpen: '0', timeSlot: [{ startTime: '00:00:00', endTime: '00:00:00' }] },
    { day: 'THURSDAY', isOpen: '0', timeSlot: [{ startTime: '00:00:00', endTime: '00:00:00' }] },
    { day: 'FRIDAY', isOpen: '0', timeSlot: [{ startTime: '00:00:00', endTime: '00:00:00' }] },
    { day: 'SATURDAY', isOpen: '0', timeSlot: [{ startTime: '00:00:00', endTime: '00:00:00' }] },
    { day: 'SUNDAY', isOpen: '0', timeSlot: [{ startTime: '00:00:00', endTime: '00:00:00' }] },
  ])

  // const addDropOffTimeField = (index: any) => {
  //     const newData = [...dropOffOpeningHourData];
  //     newData[index].timeSlot.push({ startTime: '', endTime: '' });
  //     setDropOffOpeningHourData(newData);
  // };

  const addDropOffTimeField = (index: any) => {
    const newData = [...dropOffOpeningHourData]

    // If currently closed (no time slots), set isOpen to '1'
    if (newData[index].timeSlot.length === 0) {
      newData[index].isOpen = '1'
    }

    newData[index].timeSlot.push({ startTime: '00:00:00', endTime: '00:00:00' })
    setDropOffOpeningHourData(newData)
  }

  const removeDropOffTimeField = (dayIndex: any, timeIndex: any) => {
    setDropOffOpeningHourData((prev: any) => {
      const newData = [...prev]
      newData[dayIndex].timeSlot.splice(timeIndex, 1)

      // If no time slots left, set isOpen to '0'
      if (newData[dayIndex].timeSlot.length == 0) {
        newData[dayIndex].isOpen = '0'
      }

      return newData
    })
  }

  const handleDropOffInputChange = (dayIndex: any, timeIndex: any, event: any) => {
    const { name, value } = event.target
    const parsedTime = moment(value, 'HH:mm')
    // Format the time as HH:mm:ss
    let formattedValue = parsedTime.isValid() ? parsedTime.format('HH:mm:ss') : ''
    const newData = [...dropOffOpeningHourData] as any
    // Validate start time against end time
    if (name === 'startTime') {
      const endTime = newData[dayIndex].timeSlot[timeIndex].endTime
      if (endTime && formattedValue >= endTime) {
        // Handle validation error (e.g., display error message)
        toasterrormsg('End Time Must be Greater Than Start Time')
        return // Do not update state if validation fails
      }
    } else if (name === 'endTime') {
      const startTime = newData[dayIndex].timeSlot[timeIndex].startTime
      // If endTime is entered as 00:00, replace with 23:45
      if (formattedValue === '00:00:00') {
        formattedValue = '23:45:00'
      }

      if (startTime && formattedValue <= startTime) {
        // Handle validation error (e.g., display error message)
        toasterrormsg('End Time Must be Greater Than Start Time')
        return // Do not update state if validation fails
      }
    }
    // Validate time conflicts
    for (let i = 0; i < newData[dayIndex].timeSlot.length; i++) {
      if (i !== timeIndex) {
        const existingStartTime = newData[dayIndex].timeSlot[i].startTime
        const existingEndTime = newData[dayIndex].timeSlot[i].endTime
        if (
          (formattedValue >= existingStartTime && formattedValue < existingEndTime) ||
          (existingStartTime >= formattedValue && existingStartTime < formattedValue)
        ) {
          toasterrormsg('Time Is Conflict')
          return
        }
      }
    }
    newData[dayIndex].timeSlot[timeIndex][name] = formattedValue
    setDropOffOpeningHourData(newData)
  }

  // Check if any required fields are not defined or empty
  const isDropOffOpeningHoursValid = dropOffOpeningHourData.every((opening) => {
    return opening.day && opening.timeSlot.every((slot) => slot.startTime && slot.endTime)
  })
  // set error state
  const [error, setError] = useState([
    {
      pickUpBranchNameEN: '',
      pickUpBranchNameRU: '',
      pickUpBranchNameUZ: '',
      pickUpBranchAddress: '',
      pickUpContactNumber: '',
      pickUpGettingThereEN: '',
      pickUpGettingThereRU: '',
      pickUpGettingThereUZ: '',
      pickUpInstructionEN: '',
      pickUpInstructionRU: '',
      pickUpInstructionUZ: '',
      dropOffBranchNameEN: '',
      dropOffBranchNameRU: '',
      dropOffBranchNameUZ: '',
      dropOffBranchAddress: '',
      dropOffContactNumber: '',
      dropOffGettingThereEN: '',
      dropOffGettingThereRU: '',
      dropOffGettingThereUZ: '',
      dropOffInstructionEN: '',
      dropOffInstructionRU: '',
      dropOffInstructionUZ: '',
    },
  ])

  // remove validation function
  const removeError = (err: any) => {
    var tmp = [...error] as any
    tmp[0][err] = ''
    setError(tmp)
  }

  const handlePickUpChange = (value: any, country: any, e: any, formate: any) => {
    removeError('pickUpContactNumber')
    const parts = formate.split(' ')
    const formattedValue = parts.slice(1).join(' ').replace(/\D/g, '')
    setPickUpCountryCode(country.dialCode) // get country code
    setPickUpContactNumber(formattedValue) // get mobile number without country code
  }
  const handleDropOffChange = (value: any, country: any, e: any, formate: any) => {
    removeError('dropOffContactNumber')
    const parts = formate.split(' ')
    const formattedValue = parts.slice(1).join(' ').replace(/\D/g, '')
    setDropOffCountryCode(country.dialCode) // get country code
    setDropOffContactNumber(formattedValue) // get mobile number without country code
  }
  // validation function
  const validate = () => {
    var isValid = true
    var errorTmp = [...error]
    let firstErrorField = null

    if (
      pickUpBranchAddress.trim() == '' ||
      pickUpBranchAddress.trim() == null ||
      pickUpBranchAddress.trim() == undefined
    ) {
      errorTmp[0].pickUpBranchAddress = t('Address Is Required')
      isValid = false
      if (!firstErrorField) firstErrorField = 'pickUpBranchAddress'
    }
    if (
      pickUpContactNumber.trim() == '' ||
      pickUpContactNumber.trim() == null ||
      pickUpContactNumber.trim() == undefined
    ) {
      errorTmp[0].pickUpContactNumber = t('Mobile Number Is Required')
      isValid = false
      if (!firstErrorField) firstErrorField = 'pickUpContactNumber'
    }
    if (
      dropOffBranchAddress.trim() == '' ||
      dropOffBranchAddress.trim() == null ||
      dropOffBranchAddress.trim() == undefined
    ) {
      errorTmp[0].dropOffBranchAddress = t('Address Is Required')
      isValid = false
      if (!firstErrorField) firstErrorField = 'dropOffBranchAddress'
    }
    if (
      dropOffContactNumber.trim() == '' ||
      dropOffContactNumber.trim() == null ||
      dropOffContactNumber.trim() == undefined
    ) {
      errorTmp[0].dropOffContactNumber = t('Mobile Number Is Required')
      isValid = false
      if (!firstErrorField) firstErrorField = 'dropOffContactNumber'
    }
    if (primaryLanguage == 'English') {
      if (
        pickUpBranchNameEN.trim() == '' ||
        pickUpBranchNameEN.trim() == null ||
        pickUpBranchNameEN.trim() == undefined
      ) {
        errorTmp[0].pickUpBranchNameEN = t('Branch Name Is Required')
        isValid = false
        if (!firstErrorField) firstErrorField = 'pickUpBranchNameEN'
      }
      if (
        pickUpGettingThereEN.trim() == '' ||
        pickUpGettingThereEN.trim() == null ||
        pickUpGettingThereEN.trim() == undefined
      ) {
        errorTmp[0].pickUpGettingThereEN = t('Getting There Is Required')
        isValid = false
        if (!firstErrorField) firstErrorField = 'pickUpGettingThereEN'
      }
      if (
        pickUpInstructionEN.trim() == '' ||
        pickUpInstructionEN.trim() == null ||
        pickUpInstructionEN.trim() == undefined
      ) {
        errorTmp[0].pickUpInstructionEN = t('Instruction Is Required')
        isValid = false
        if (!firstErrorField) firstErrorField = 'pickUpInstructionEN'
      }
      if (
        dropOffBranchNameEN.trim() == '' ||
        dropOffBranchNameEN.trim() == null ||
        dropOffBranchNameEN.trim() == undefined
      ) {
        errorTmp[0].dropOffBranchNameEN = t('Branch Name Is Required')
        isValid = false
        if (!firstErrorField) firstErrorField = 'dropOffBranchNameEN'
      }
      if (
        dropOffGettingThereEN.trim() == '' ||
        dropOffGettingThereEN.trim() == null ||
        dropOffGettingThereEN.trim() == undefined
      ) {
        errorTmp[0].dropOffGettingThereEN = t('Getting There Is Required')
        isValid = false
        if (!firstErrorField) firstErrorField = 'dropOffGettingThereEN'
      }
      if (
        dropOffInstructionEN.trim() == '' ||
        dropOffInstructionEN.trim() == null ||
        dropOffInstructionEN.trim() == undefined
      ) {
        errorTmp[0].dropOffInstructionEN = t('Instruction Is Required')
        isValid = false
        if (!firstErrorField) firstErrorField = 'dropOffInstructionEN'
      }
    } else if (primaryLanguage == 'Russian') {
      if (
        pickUpBranchNameRU.trim() == '' ||
        pickUpBranchNameRU.trim() == null ||
        pickUpBranchNameRU.trim() == undefined
      ) {
        errorTmp[0].pickUpBranchNameRU = t('Branch Name Is Required')
        isValid = false
        if (!firstErrorField) firstErrorField = 'pickUpBranchNameRU'
      }
      if (
        pickUpGettingThereRU.trim() == '' ||
        pickUpGettingThereRU.trim() == null ||
        pickUpGettingThereRU.trim() == undefined
      ) {
        errorTmp[0].pickUpGettingThereRU = t('Getting There Is Required')
        isValid = false
        if (!firstErrorField) firstErrorField = 'pickUpGettingThereRU'
      }
      if (
        pickUpInstructionRU.trim() == '' ||
        pickUpInstructionRU.trim() == null ||
        pickUpInstructionRU.trim() == undefined
      ) {
        errorTmp[0].pickUpInstructionRU = t('Instruction Is Required')
        isValid = false
        if (!firstErrorField) firstErrorField = 'pickUpInstructionRU'
      }
      if (
        dropOffBranchNameRU.trim() == '' ||
        dropOffBranchNameRU.trim() == null ||
        dropOffBranchNameRU.trim() == undefined
      ) {
        errorTmp[0].dropOffBranchNameRU = t('Branch Name Is Required')
        isValid = false
        if (!firstErrorField) firstErrorField = 'dropOffBranchNameRU'
      }
      if (
        dropOffGettingThereRU.trim() == '' ||
        dropOffGettingThereRU.trim() == null ||
        dropOffGettingThereRU.trim() == undefined
      ) {
        errorTmp[0].dropOffGettingThereRU = t('Getting There Is Required')
        isValid = false
        if (!firstErrorField) firstErrorField = 'dropOffGettingThereRU'
      }
      if (
        dropOffInstructionRU.trim() == '' ||
        dropOffInstructionRU.trim() == null ||
        dropOffInstructionRU.trim() == undefined
      ) {
        errorTmp[0].dropOffInstructionRU = t('Instruction Is Required')
        isValid = false
        if (!firstErrorField) firstErrorField = 'dropOffInstructionRU'
      }
    } else if (primaryLanguage == 'Uzbek') {
      if (
        pickUpBranchNameUZ.trim() == '' ||
        pickUpBranchNameUZ.trim() == null ||
        pickUpBranchNameUZ.trim() == undefined
      ) {
        errorTmp[0].pickUpBranchNameUZ = t('Branch Name Is Required')
        isValid = false
        if (!firstErrorField) firstErrorField = 'pickUpBranchNameUZ'
      }
      if (
        pickUpGettingThereUZ.trim() == '' ||
        pickUpGettingThereUZ.trim() == null ||
        pickUpGettingThereUZ.trim() == undefined
      ) {
        errorTmp[0].pickUpGettingThereUZ = t('Getting There Is Required')
        isValid = false
        if (!firstErrorField) firstErrorField = 'pickUpGettingThereUZ'
      }
      if (
        pickUpInstructionUZ.trim() == '' ||
        pickUpInstructionUZ.trim() == null ||
        pickUpInstructionUZ.trim() == undefined
      ) {
        errorTmp[0].pickUpInstructionUZ = t('Instruction Is Required')
        isValid = false
        if (!firstErrorField) firstErrorField = 'pickUpInstructionUZ'
      }
      if (
        dropOffBranchNameUZ.trim() == '' ||
        dropOffBranchNameUZ.trim() == null ||
        dropOffBranchNameUZ.trim() == undefined
      ) {
        errorTmp[0].dropOffBranchNameUZ = t('Branch Name Is Required')
        isValid = false
        if (!firstErrorField) firstErrorField = 'dropOffBranchNameUZ'
      }
      if (
        dropOffGettingThereUZ.trim() == '' ||
        dropOffGettingThereUZ.trim() == null ||
        dropOffGettingThereUZ.trim() == undefined
      ) {
        errorTmp[0].dropOffGettingThereUZ = t('Getting There Is Required')
        isValid = false
        if (!firstErrorField) firstErrorField = 'dropOffGettingThereUZ'
      }
      if (
        dropOffInstructionUZ.trim() == '' ||
        dropOffInstructionUZ.trim() == null ||
        dropOffInstructionUZ.trim() == undefined
      ) {
        errorTmp[0].dropOffInstructionUZ = t('Instruction Is Required')
        isValid = false
        if (!firstErrorField) firstErrorField = 'dropOffInstructionUZ'
      }
    }
    setError(errorTmp)
    if (!isValid && firstErrorField) {
      const element = document.getElementById(firstErrorField)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    }
    return isValid
  }

  function getDayNumber(day: any) {
    switch (day.toLowerCase()) {
      case 'monday':
        return 1
      case 'tuesday':
        return 2
      case 'wednesday':
        return 3
      case 'thursday':
        return 4
      case 'friday':
        return 5
      case 'saturday':
        return 6
      case 'sunday':
        return 7
      default:
        return 0 // For any other case
    }
  }
  const carRentalDetailsApiCall = async () => {
    var param: any = {
      carrentalId: String(editCarrentalId),
    }
    var response: any = await fetchData('vendor/public/carRentalDetail', param)
    if (response.status == '200') {
      setCarRentalDetails(response.data)
      var data = response.data[0]
      setPickUpBranchNameEN(data.en_pickupBranchName)
      setPickUpBranchNameRU(data.ru_pickupBranchName)
      setPickUpBranchNameUZ(data.uz_pickupBranchName)
      setPickUpGettingThereEN(data.en_pickupHowGettingThere)
      setPickUpGettingThereRU(data.ru_pickupHowGettingThere)
      setPickUpGettingThereUZ(data.uz_pickupHowGettingThere)
      setPickUpInstructionEN(data.en_pickupInstruction)
      setPickUpInstructionRU(data.ru_pickupInstruction)
      setPickUpInstructionUZ(data.uz_pickupInstruction)
      setPickUpCountryCode(data.pickupCountryCode)
      setPickUpContactNumber(data.pickupContactNumber)
      setPickUpBranchCountry(data.pickupCountry)
      setPickUpBranchState(data.pickupState)
      setPickUpBranchCity(data.pickupCity)
      setPickUpBranchAddress(data.pickupBranchAddress)
      setPickUpBranchLongitude(data.pickupLongitude)
      setPickUpBranchLatitude(data.pickupLatitude)
      if (data['pickupOpeningHour'].length != 0) {
        var pickupOpeningHour = data['pickupOpeningHour'].map((item: any) => {
          return {
            transportationopeninghoursId: item.transportationopeninghoursId,
            day: item.day,
            timeSlot: item.timeSlot,
            isOpen: item.timeSlot.length > 0 ? '1' : '0',
          }
        })
        // Sort the opening hours based on the day of the week
        pickupOpeningHour.sort((a: any, b: any) => {
          return getDayNumber(a.day) - getDayNumber(b.day)
        })
        setPickupOpeningHourData(pickupOpeningHour)
      }

      setDropOffBranchNameEN(data.en_dropoffBranchName)
      setDropOffBranchNameRU(data.ru_dropoffBranchName)
      setDropOffBranchNameUZ(data.uz_dropoffBranchName)
      setDropOffGettingThereEN(data.en_dropoffHowGettingThere)
      setDropOffGettingThereRU(data.ru_dropoffHowGettingThere)
      setDropOffGettingThereUZ(data.uz_dropoffHowGettingThere)
      setDropOffInstructionEN(data.en_dropoffInstruction)
      setDropOffInstructionRU(data.ru_dropoffInstruction)
      setDropOffInstructionUZ(data.uz_dropoffInstruction)
      setDropOffCountryCode(data.dropoffCountryCode)
      setDropOffContactNumber(data.dropoffContactNumber)
      setDropOffBranchCountry(data.dropoffCountry)
      setDropOffBranchState(data.dropoffState)
      setDropOffBranchCity(data.dropoffCity)
      setDropOffBranchAddress(data.dropoffBranchAddress)
      setDropOffBranchLongitude(data.dropoffLongitude)
      setDropOffBranchLatitude(data.dropoffLatitude)
      if (data['dropoffOpeningHour'].length != 0) {
        var dropoffOpeningHour = data['dropoffOpeningHour'].map((item: any) => {
          return {
            transportationopeninghoursId: item.transportationopeninghoursId,
            day: item.day,
            timeSlot: item.timeSlot,
            isOpen: item.timeSlot.length > 0 ? '1' : '0',
          }
        })
        // Sort the opening hours based on the day of the week
        dropoffOpeningHour.sort((a: any, b: any) => {
          return getDayNumber(a.day) - getDayNumber(b.day)
        })
        setDropOffOpeningHourData(dropoffOpeningHour)
      }
    } else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {
    if (editCarrentalId != '') {
      carRentalDetailsApiCall()
    }
  }, [])
  const addPickupOrDropoffApi = async () => {
    if (validate()) {
      if (isPickupOpeningHoursValid) {
        if (isDropOffOpeningHoursValid) {
          setDisable(true)
          setLoading(true)
          var param: any = {
            carrentalId: String(editCarrentalId),
            en_pickupBranchName: pickUpBranchNameEN,
            ru_pickupBranchName: pickUpBranchNameRU,
            uz_pickupBranchName: pickUpBranchNameUZ,
            en_pickupHowGettingThere: pickUpGettingThereEN,
            ru_pickupHowGettingThere: pickUpGettingThereRU,
            uz_pickupHowGettingThere: pickUpGettingThereUZ,
            en_pickupInstruction: pickUpInstructionEN,
            ru_pickupInstruction: pickUpInstructionRU,
            uz_pickupInstruction: pickUpInstructionUZ,
            pickupContactNumber: pickUpContactNumber,
            pickupCountryCode: pickUpCountryCode,
            pickupBranchAddress: pickUpBranchAddress,
            pickupLongitude: pickUpBranchLongitude,
            pickupLatitude: pickUpBranchLatitude,
            pickupCountry: pickUpBranchCountry,
            pickupState: pickUpBranchState,
            pickupCity: pickUpBranchCity,
            en_dropoffBranchName: dropOffBranchNameEN,
            uz_dropoffBranchName: dropOffBranchNameRU,
            ru_dropoffBranchName: dropOffBranchNameUZ,
            en_dropoffHowGettingThere: dropOffGettingThereEN,
            uz_dropoffHowGettingThere: dropOffGettingThereRU,
            ru_dropoffHowGettingThere: dropOffGettingThereUZ,
            en_dropoffInstruction: dropOffInstructionEN,
            uz_dropoffInstruction: dropOffInstructionRU,
            ru_dropoffInstruction: dropOffInstructionUZ,
            dropoffContactNumber: dropOffContactNumber,
            dropoffCountryCode: dropOffCountryCode,
            dropoffBranchAddress: dropOffBranchAddress,
            dropoffLongitude: dropOffBranchLongitude,
            dropoffLatitude: dropOffBranchLatitude,
            dropoffCountry: dropOffBranchCountry,
            dropoffState: dropOffBranchState,
            dropoffCity: dropOffBranchCity,
            pickupOpeningHour: pickupOpeningHourData,
            dropoffOpeningHour: dropOffOpeningHourData,
          }
          var response: any = await fetchData('vendor/public/addPickupAndDropoff', param)
          if (response.status == '200') {
            toastsuccessmsg('Pick-Up And Drop-Off Info Saved Successfully!')
            const state = {
              carrentalId: editCarrentalId,
            }
            setTimeout(() => {
              navigate(getEncryptedRoute('../addcarrentalpolicies/', { menuId: menuId }), { state })

              setDisable(false)
              setLoading(false)
            }, 1500)
          } else {
            toasterrormsg(response.message)
            setDisable(false)
            setLoading(false)
          }
        } else {
          toasterrormsg('Please Select Dropoff Opening Hours')
          return
        }
      } else {
        toasterrormsg('Please Select Pickup Opening Hours')
        return
      }
    }
  }
  const toggleDayOpenPickUp = (dayIndex: number) => {
    setPickupOpeningHourData((prev: any) =>
      prev.map((day: any, index: number) => {
        if (index === dayIndex) {
          const newIsOpen = day.isOpen === '1' ? '0' : '1'
          return {
            ...day,
            isOpen: newIsOpen,
            timeSlot:
              newIsOpen === '1'
                ? [{ startTime: '00:00:00', endTime: '00:00:00' }] // open → add default slot
                : [], // close → clear all slots
          }
        }
        return day
      })
    )
  }
  const toggleDayOpenDropOff = (dayIndex: number) => {
    setDropOffOpeningHourData((prev: any) =>
      prev.map((day: any, index: number) => {
        if (index === dayIndex) {
          const newIsOpen = day.isOpen === '1' ? '0' : '1'
          return {
            ...day,
            isOpen: newIsOpen,
            timeSlot:
              newIsOpen === '1'
                ? [{ startTime: '00:00:00', endTime: '00:00:00' }] // open → add default slot
                : [], // close → clear all slots
          }
        }
        return day
      })
    )
  }
  return (
    <>
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>
        {editCarrentalId != '' ? t('Edit Instruction') : t('Add Instruction')}
      </PageTitle>
      <AddCarRentalHeader carrentalId={editCarrentalId} />
      <div className='d-flex flex-column flex-column-fluid'>
        {/* <!--begin::Content--> */}
        <div id='kt_app_content' className='app-content flex-column-fluid'>
          {/* <!--begin::Form--> */}
          <div className='form d-flex flex-column flex-lg-row'>
            {/* <!--begin::Main column--> */}
            <div className='d-flex flex-column flex-row-fluid gap-7 gap-lg-10'>
              {/* <!--begin::Tab content--> */}
              <div className='tab-content'>
                {/* <!--begin::Tab pane--> */}
                <div
                  className='tab-pane fade show active'
                  id='kt_ecommerce_add_product_general'
                  role='tab-panel'
                >
                  <div className='d-flex flex-column'>
                    {/* <!--begin::General options--> */}
                    <div className='card card-flush py-4'>
                      {/* <!--begin::Card header--> */}
                      <div className='card-header d-flex'>
                        {/* <!--begin::Card title--> */}
                        <div className='card-title'>
                          <h2>{t('Pick-Up & Drop-Off Information')}</h2>
                        </div>
                        {/* <!--end::Card title--> */}
                        <div className='d-flex align-items-center w-200px w-sm-300px flex-column'>
                          {carRentalDetails.length != 0 ? (
                            <>
                              {carRentalDetails.map((completedSteps: any, index: any) => {
                                var percentage = 0
                                if (completedSteps['completedSteps']['basicInfo']) {
                                  percentage = 10
                                }
                                if (completedSteps['completedSteps']['location']) {
                                  percentage = 20
                                }
                                if (completedSteps['completedSteps']['carRentalInfo']) {
                                  percentage = 40
                                }
                                if (completedSteps['completedSteps']['photos']) {
                                  percentage = 50
                                }
                                if (completedSteps['completedSteps']['insurance']) {
                                  percentage = 60
                                }
                                if (completedSteps['completedSteps']['documentsRequired']) {
                                  percentage = 70
                                }
                                if (completedSteps['completedSteps']['availability']) {
                                  percentage = 70
                                }
                                if (completedSteps['completedSteps']['pickupDropoffInfo']) {
                                  percentage = 80
                                }
                                if (completedSteps['completedSteps']['policies']) {
                                  percentage = 90
                                }
                                if (completedSteps['completedSteps']['financeAndLegal']) {
                                  percentage = 100
                                }
                                return (
                                  <>
                                    <div className='d-flex justify-content-between w-100 mt-auto'>
                                      <span className='fw-bold fs-6'>{t('Completion')}</span>
                                      <span className='fw-bolder fs-6'>{percentage}%</span>
                                    </div>
                                    <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                      <div
                                        className='bg-success rounded h-5px'
                                        role='progressbar'
                                        style={{ width: `${percentage}%` }}
                                      ></div>
                                    </div>
                                  </>
                                )
                              })}
                            </>
                          ) : (
                            <>
                              <div className='d-flex justify-content-between w-100 mt-auto'>
                                <span className='fw-bold fs-6'>{t('Completion')}</span>
                                <span className='fw-bolder fs-6'>0%</span>
                              </div>
                              <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                <div
                                  className='bg-success rounded h-5px'
                                  role='progressbar'
                                  style={{ width: '0%' }}
                                ></div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                      {/* <!--end::Card header--> */}
                      {/* <!--begin::Card body--> */}
                      <div className='card-body pt-10'>
                        <div className='row'>
                          <div className='col-lg-12'>
                            <label className='fs-2 form-label fw-bold'>{t('Pick-Up:')}</label>
                          </div>
                        </div>
                        {/* <!--begin::Input group--> */}
                        {primaryLanguage == 'English' && (
                          <>
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>
                                  {t('Branch Name (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  id='pickUpBranchNameEN'
                                  name='pickUpBranchNameEN'
                                  className='form-control mb-2'
                                  placeholder={t('Branch Name')}
                                  value={pickUpBranchNameEN}
                                  onChange={(e) => {
                                    setPickUpBranchNameEN(e.target.value)
                                    removeError('pickUpBranchNameEN')
                                  }}
                                />
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>
                                  {error[0].pickUpBranchNameEN}
                                </div>
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Branch Name (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  id='pickUpBranchNameRU'
                                  name='pickUpBranchNameRU'
                                  className='form-control mb-2'
                                  placeholder={t('Branch Name')}
                                  value={pickUpBranchNameRU}
                                  onChange={(e) => {
                                    setPickUpBranchNameRU(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Branch Name (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='pickUpBranchNameUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Branch Name')}
                                  id='pickUpBranchNameUZ'
                                  value={pickUpBranchNameUZ}
                                  onChange={(e) => {
                                    setPickUpBranchNameUZ(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>
                                  {t('How Getting There? (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='pickUpGettingThereEN'
                                  id='pickUpGettingThereEN'
                                  className='form-control mb-2'
                                  placeholder={t('Getting There')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setPickUpGettingThereEN(e.target.value)
                                    removeError('pickUpGettingThereEN')
                                  }}
                                  value={pickUpGettingThereEN}
                                ></textarea>
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>
                                  {error[0].pickUpGettingThereEN}
                                </div>
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className=' fs-4 form-label'>
                                  {t('How Getting There? (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='pickUpGettingThereRU'
                                  id='pickUpGettingThereRU'
                                  className='form-control mb-2'
                                  placeholder={t('Getting There')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setPickUpGettingThereRU(e.target.value)
                                    removeError('pickUpGettingThereRU')
                                  }}
                                  value={pickUpGettingThereRU}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className=' fs-4 form-label'>
                                  {t('How Getting There? (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='pickUpGettingThereUZ'
                                  id='pickUpGettingThereUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Getting There')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setPickUpGettingThereUZ(e.target.value)
                                    removeError('pickUpGettingThereUZ')
                                  }}
                                  value={pickUpGettingThereUZ}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>
                                  {t('Instruction (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='pickUpInstructionEN'
                                  id='pickUpInstructionEN'
                                  className='form-control mb-2'
                                  placeholder={t('Instruction')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setPickUpInstructionEN(e.target.value)
                                    removeError('pickUpInstructionEN')
                                  }}
                                  value={pickUpInstructionEN}
                                ></textarea>
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>
                                  {error[0].pickUpInstructionEN}
                                </div>
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className=' fs-4 form-label'>
                                  {t('Instruction (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='pickUpInstructionRU'
                                  id='pickUpInstructionRU'
                                  className='form-control mb-2'
                                  placeholder={t('Instruction')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setPickUpInstructionRU(e.target.value)
                                    removeError('pickUpInstructionRU')
                                  }}
                                  value={pickUpInstructionRU}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className=' fs-4 form-label'>
                                  {t('Instruction (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='pickUpInstructionUZ'
                                  id='pickUpInstructionUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Instruction')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setPickUpInstructionUZ(e.target.value)
                                    removeError('pickUpInstructionUZ')
                                  }}
                                  value={pickUpInstructionUZ}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                          </>
                        )}
                        {primaryLanguage == 'Russian' && (
                          <>
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>
                                  {t('Branch Name (Russian)')}
                                </label>

                                <input
                                  type='text'
                                  name='pickUpBranchNameRU'
                                  id='pickUpBranchNameRU'
                                  className='form-control mb-2'
                                  placeholder={t('Branch Name')}
                                  value={pickUpBranchNameRU}
                                  onChange={(e) => {
                                    setPickUpBranchNameRU(e.target.value)
                                    removeError('pickUpBranchNameRU')
                                  }}
                                />
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>
                                  {error[0].pickUpBranchNameRU}
                                </div>
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className=' fs-4 form-label'>
                                  {t('Branch Name (English)')}
                                </label>

                                <input
                                  type='text'
                                  name='pickUpBranchNameEN'
                                  id='pickUpBranchNameEN'
                                  className='form-control mb-2'
                                  placeholder={t('Branch Name')}
                                  value={pickUpBranchNameEN}
                                  onChange={(e) => {
                                    setPickUpBranchNameEN(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Branch Name (Uzbek)')}
                                </label>

                                <input
                                  type='text'
                                  name='pickUpBranchNameUZ'
                                  id='pickUpBranchNameUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Branch Name')}
                                  value={pickUpBranchNameUZ}
                                  onChange={(e) => {
                                    setPickUpBranchNameUZ(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>
                                  {t('How Getting There? (Russian)')}
                                </label>

                                <textarea
                                  name='pickUpGettingThereRU'
                                  id='pickUpGettingThereRU'
                                  className='form-control mb-2'
                                  placeholder={t('Getting There')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setPickUpGettingThereRU(e.target.value)
                                    removeError('pickUpGettingThereRU')
                                  }}
                                  value={pickUpGettingThereRU}
                                ></textarea>
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>
                                  {error[0].pickUpGettingThereRU}
                                </div>
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className=' fs-4 form-label'>
                                  {t('How Getting There? (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='pickUpGettingThereEN'
                                  id='pickUpGettingThereEN'
                                  className='form-control mb-2'
                                  placeholder={t('Getting There')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setPickUpGettingThereEN(e.target.value)
                                  }}
                                  value={pickUpGettingThereEN}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className=' fs-4 form-label'>
                                  {t('How Getting There? (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='pickUpGettingThereUZ'
                                  id='pickUpGettingThereUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Getting There')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setPickUpGettingThereUZ(e.target.value)
                                  }}
                                  value={pickUpGettingThereUZ}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>
                                  {t('Instruction (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='pickUpInstructionRU'
                                  id='pickUpInstructionRU'
                                  className='form-control mb-2'
                                  placeholder={t('Instruction')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setPickUpInstructionRU(e.target.value)
                                    removeError('pickUpInstructionRU')
                                  }}
                                  value={pickUpInstructionRU}
                                ></textarea>
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>
                                  {error[0].pickUpInstructionRU}
                                </div>
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className=' fs-4 form-label'>
                                  {t('Instruction (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='pickUpInstructionEN'
                                  id='pickUpInstructionEN'
                                  className='form-control mb-2'
                                  placeholder={t('Instruction')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setPickUpInstructionEN(e.target.value)
                                  }}
                                  value={pickUpInstructionEN}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className=' fs-4 form-label'>
                                  {t('Instruction (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='pickUpInstructionUZ'
                                  id='pickUpInstructionUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Instruction')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setPickUpInstructionUZ(e.target.value)
                                  }}
                                  value={pickUpInstructionUZ}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                          </>
                        )}
                        {primaryLanguage == 'Uzbek' && (
                          <>
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>
                                  {t('Branch Name (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='pickUpBranchNameUZ'
                                  id='pickUpBranchNameUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Branch Name')}
                                  value={pickUpBranchNameUZ}
                                  onChange={(e) => {
                                    setPickUpBranchNameUZ(e.target.value)
                                    removeError('pickUpBranchNameUZ')
                                  }}
                                />
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>
                                  {error[0].pickUpBranchNameUZ}
                                </div>
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className=' fs-4 form-label'>
                                  {t('Branch Name (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='pickUpBranchNameRU'
                                  id='pickUpBranchNameRU'
                                  className='form-control mb-2'
                                  placeholder={t('Branch Name')}
                                  value={pickUpBranchNameRU}
                                  onChange={(e) => {
                                    setPickUpBranchNameRU(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className=' fs-4 form-label'>
                                  {t('Branch Name (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='pickUpBranchNameEN'
                                  id='pickUpBranchNameEN'
                                  className='form-control mb-2'
                                  placeholder={t('Branch Name')}
                                  value={pickUpBranchNameEN}
                                  onChange={(e) => {
                                    setPickUpBranchNameEN(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>
                                  {t('How Getting There? (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='pickUpGettingThereUZ'
                                  id='pickUpGettingThereUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Getting There')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setPickUpGettingThereUZ(e.target.value)
                                    removeError('pickUpGettingThereRU')
                                  }}
                                  value={pickUpGettingThereUZ}
                                ></textarea>
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>
                                  {error[0].pickUpGettingThereUZ}
                                </div>
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className=' fs-4 form-label'>
                                  {t('How Getting There? (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='pickUpGettingThereRU'
                                  id='pickUpGettingThereRU'
                                  className='form-control mb-2'
                                  placeholder={t('Getting There')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setPickUpGettingThereRU(e.target.value)
                                  }}
                                  value={pickUpGettingThereRU}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className=' fs-4 form-label'>
                                  {t('How Getting There? (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='pickUpGettingThereEN'
                                  id='pickUpGettingThereEN'
                                  className='form-control mb-2'
                                  placeholder={t('Getting There')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setPickUpGettingThereEN(e.target.value)
                                  }}
                                  value={pickUpGettingThereEN}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>
                                  {t('Instruction (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='pickUpInstructionUZ'
                                  id='pickUpInstructionUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Instruction')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setPickUpInstructionUZ(e.target.value)
                                    removeError('pickUpInstructionUZ')
                                  }}
                                  value={pickUpInstructionUZ}
                                ></textarea>
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>
                                  {error[0].pickUpInstructionUZ}
                                </div>
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className=' fs-4 form-label'>
                                  {t('Instruction (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='pickUpInstructionRU'
                                  id='pickUpInstructionRU'
                                  className='form-control mb-2'
                                  placeholder={t('Instruction')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setPickUpInstructionRU(e.target.value)
                                  }}
                                  value={pickUpInstructionRU}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className=' fs-4 form-label'>
                                  {t('Instruction (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='pickUpInstructionEN'
                                  id='pickUpInstructionEN'
                                  className='form-control mb-2'
                                  placeholder={t('Instruction')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setPickUpInstructionEN(e.target.value)
                                  }}
                                  value={pickUpInstructionEN}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                          </>
                        )}
                        {/* <!--end::Input group--> */}
                        {/* <!--begin::Input group--> */}
                        <div className='row'>
                          <div className='col-lg-6 my-3'>
                            <label className='required fs-4 form-label'>
                              {t('Branch Address')}
                            </label>
                            <AutoComplete
                              name='location'
                              id='pickUpBranchAddress'
                              placeholder={t('Enter Location')}
                              value={pickUpBranchAddress}
                              onAddressSelect={(address: any) => {
                                setPickUpBranchAddress(address)
                                removeError('pickUpBranchAddress')
                              }}
                              longitude={(lng: any) => setPickUpBranchLongitude(lng)}
                              latitude={(lat: any) => setPickUpBranchLatitude(lat)}
                              country={(cnt: any) => setPickUpBranchCountry(cnt)}
                              state={(st: any) => setPickUpBranchState(st)}
                              city={(ct: any) => setPickUpBranchCity(ct)}
                            />
                            <div className='text-danger fw-bold'>
                              {error[0].pickUpBranchAddress}
                            </div>
                            <br />
                            <GoogleMapComponent2
                              latitude={pickUpBranchLatitude}
                              longitude={pickUpBranchLongitude}
                              onSelectLocation={(e: any) => setPickUpLocationObj(e)}
                            />
                          </div>
                          <div className='col-lg-6 my-3'>
                            {/* <!--begin::Label--> */}
                            <label id='pickUpContactNumber' className='fs-4 required form-label'>
                              {t('Contact Number')}
                            </label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <PhoneInput
                              inputClass='form-control form-control-solid w-100'
                              placeholder={t('Enter Mobile Number')}
                              enableSearch={true}
                              value={pickUpCountryCode + pickUpContactNumber}
                              country={'uz'}
                              onChange={handlePickUpChange}
                            />
                            {/* end::Form group */}
                            <div className='text-danger fw-bold'>
                              {error[0].pickUpContactNumber}
                            </div>
                            {/* <!--end::Input--> */}
                          </div>
                        </div>
                        {/* <!--end::Input group--> */}
                      </div>
                      <div className='card-body pt-7'>
                        <label className='required fs-4 form-label'>{t('Business Hours')}</label>
                        {pickupOpeningHourData.map((dayData, dayIndex) => (
                          <div className='row' key={dayIndex}>
                            {/* <div className='col-lg-1'></div> */}
                            <div className='col-lg-2 my-3 d-flex justify-content-between align-items-center'>
                              {/* <label className="fs-4 form-label">Day</label> */}
                              <h5 className='mt-lg-5'>
                                {t(dayData.day.charAt(0).toUpperCase() + t(dayData.day).slice(1).toLowerCase())}
                              </h5>
                              {/* {dayData.timeSlot.length === 0 && (
                                <button
                                  className='btn btn-success mt-lg-10'
                                  onClick={() => addPickupTimeField(dayIndex)}
                                >
                                  {t('Add')}
                                </button>
                              )} */}
                            </div>
                            <div className='col-lg-2 d-flex align-items-center'>
                              <div className='form-check form-check-custom form-check-solid form-check-success form-switch'>
                                <input
                                  className='form-check-input cursor-pointer'
                                  type='checkbox'
                                  id={`flexSwitchCheckDefault${dayIndex}`}
                                  checked={dayData.isOpen == '1'}
                                  onChange={() => toggleDayOpenPickUp(dayIndex)}
                                />
                                <label
                                  className='form-check-label text-gray-700 fw-bold ms-2'
                                  htmlFor={`flexSwitchCheckDefault${dayIndex}`}
                                  data-bs-toggle='tooltip'
                                  title={
                                    dayData.isOpen == '1' ? 'Currently Open' : 'Currently Closed'
                                  }
                                >
                                  {dayData.isOpen == '1' ? t('Open') : t('Closed')}
                                </label>
                              </div>
                            </div>
                            <div className='col-lg-8 my-3'>
                              {dayData.timeSlot.map((timeSlot, timeIndex) => (
                                <div className='row' key={timeIndex}>
                                  <div className='col col-lg-5'>
                                    <label className='fs-4 form-label required'>
                                      {t('Start Time')}
                                    </label>
                                    <Flatpickr
                                      data-enable-time
                                      value={moment(timeSlot.startTime, 'HH:mm:ss').format('HH:mm')}
                                      onChange={(date) => {
                                        const formattedTime = handleTimeChange(date)
                                        handlePickupInputChange(dayIndex, timeIndex, {
                                          target: { name: 'startTime', value: formattedTime },
                                        })
                                      }}
                                      options={{
                                        enableTime: true, // Enable time selection
                                        noCalendar: true, // Hide the date picker, only show time
                                        dateFormat: 'H:i', // 24-hour format (H:i)
                                        time_24hr: true, // Enforces 24-hour format
                                        minuteIncrement: 15, // 15-minute increments in dropdown
                                        allowInput: false, // Allow typing custom times
                                      }}
                                      defaultValue={'00:00'}
                                      className='form-control mb-2'
                                    />
                                  </div>
                                  <div className='col col-lg-5'>
                                    <label className='fs-4 form-label required'>
                                      {t('End Time')}
                                    </label>
                                    <Flatpickr
                                      data-enable-time
                                      value={moment(timeSlot.endTime, 'HH:mm:ss').format('HH:mm')}
                                      onChange={(date) => {
                                        const formattedTime = handleTimeChange(date)
                                        handlePickupInputChange(dayIndex, timeIndex, {
                                          target: { name: 'endTime', value: formattedTime },
                                        })
                                      }}
                                      options={{
                                        enableTime: true, // Enable time selection
                                        noCalendar: true, // Hide the date picker, only show time
                                        dateFormat: 'H:i', // 24-hour format (H:i)
                                        time_24hr: true, // Enforces 24-hour format
                                        minuteIncrement: 15, // 15-minute increments in dropdown
                                        allowInput: false, // Allow typing custom times
                                      }}
                                      defaultValue={'00:00'}
                                      className='form-control mb-2'
                                    />
                                  </div>
                                  <div className='col col-lg-2 d-flex justify-content-lg-start justify-content-end align-items-end'>
                                    {dayData.timeSlot.length > 1 ||
                                      (dayData.timeSlot.length === 1 && timeIndex === 0) ? (
                                      <button
                                        className='btn btn-danger mb-2'
                                        onClick={() => removePickUpTimeField(dayIndex, timeIndex)}
                                      >
                                        X
                                      </button>
                                    ) : null}
                                    {timeIndex === dayData.timeSlot.length - 1 && (
                                      <button
                                        className='btn btn-success mb-2'
                                        onClick={() => addPickupTimeField(dayIndex)}
                                      >
                                        +
                                      </button>
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className='card-body pt-10'>
                        <div className='row'>
                          <div className='col-lg-12'>
                            <label className='fs-2 form-label fw-bold'>{t('Drop-Off:')}</label>
                          </div>
                        </div>
                        {/* <!--begin::Input group--> */}
                        {primaryLanguage == 'English' && (
                          <>
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>
                                  {t('Branch Name (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  id='dropOffBranchNameEN'
                                  name='dropOffBranchNameEN'
                                  className='form-control mb-2'
                                  placeholder={t('Branch Name')}
                                  value={dropOffBranchNameEN}
                                  onChange={(e) => {
                                    setDropOffBranchNameEN(e.target.value)
                                    removeError('dropOffBranchNameEN')
                                  }}
                                />
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>
                                  {error[0].dropOffBranchNameEN}
                                </div>
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Branch Name (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  id='dropOffBranchNameRU'
                                  name='dropOffBranchNameRU'
                                  className='form-control mb-2'
                                  placeholder={t('Branch Name')}
                                  value={dropOffBranchNameRU}
                                  onChange={(e) => {
                                    setDropOffBranchNameRU(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Branch Name (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  id='dropOffBranchNameUZ'
                                  name='dropOffBranchNameUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Branch Name')}
                                  value={dropOffBranchNameUZ}
                                  onChange={(e) => {
                                    setDropOffBranchNameUZ(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>
                                  {t('How Getting There? (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='dropOffGettingThereEN'
                                  id='dropOffGettingThereEN'
                                  className='form-control mb-2'
                                  placeholder={t('Getting There')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setDropOffGettingThereEN(e.target.value)
                                    removeError('dropOffGettingThereEN')
                                  }}
                                  value={dropOffGettingThereEN}
                                ></textarea>
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>
                                  {error[0].dropOffGettingThereEN}
                                </div>
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className=' fs-4 form-label'>
                                  {t('How Getting There? (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='dropOffGettingThereRU'
                                  id='dropOffGettingThereRU'
                                  className='form-control mb-2'
                                  placeholder={t('Getting There')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setDropOffGettingThereRU(e.target.value)
                                    removeError('dropOffGettingThereRU')
                                  }}
                                  value={dropOffGettingThereRU}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className=' fs-4 form-label'>
                                  {t('How Getting There? (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='dropOffGettingThereUZ'
                                  id='dropOffGettingThereUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Getting There')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setDropOffGettingThereUZ(e.target.value)
                                    removeError('dropOffGettingThereUZ')
                                  }}
                                  value={dropOffGettingThereUZ}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>
                                  {t('Instruction (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='dropOffInstructionEN'
                                  id='dropOffInstructionEN'
                                  className='form-control mb-2'
                                  placeholder={t('Instruction')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setDropOffInstructionEN(e.target.value)
                                    removeError('dropOffInstructionEN')
                                  }}
                                  value={dropOffInstructionEN}
                                ></textarea>
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>
                                  {error[0].dropOffInstructionEN}
                                </div>
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className=' fs-4 form-label'>
                                  {t('Instruction (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='dropOffInstructionRU'
                                  id='dropOffInstructionRU'
                                  className='form-control mb-2'
                                  placeholder={t('Instruction')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setDropOffInstructionRU(e.target.value)
                                    removeError('dropOffInstructionRU')
                                  }}
                                  value={dropOffInstructionRU}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className=' fs-4 form-label'>
                                  {t('Instruction (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='dropOffInstructionUZ'
                                  id='dropOffInstructionUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Instruction')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setDropOffInstructionUZ(e.target.value)
                                    removeError('dropOffInstructionUZ')
                                  }}
                                  value={dropOffInstructionUZ}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                          </>
                        )}
                        {primaryLanguage == 'Russian' && (
                          <>
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>
                                  {t('Branch Name (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='dropOffBranchNameRU'
                                  id='dropOffBranchNameRU'
                                  className='form-control mb-2'
                                  placeholder={t('Branch Name')}
                                  value={dropOffBranchNameRU}
                                  onChange={(e) => {
                                    setDropOffBranchNameRU(e.target.value)
                                    removeError('dropOffBranchNameRU')
                                  }}
                                />
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>
                                  {error[0].dropOffBranchNameRU}
                                </div>
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className=' fs-4 form-label'>
                                  {t('Branch Name (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='dropOffBranchNameEN'
                                  id='dropOffBranchNameEN'
                                  className='form-control mb-2'
                                  placeholder={t('Branch Name')}
                                  value={dropOffBranchNameEN}
                                  onChange={(e) => {
                                    setDropOffBranchNameEN(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Branch Name (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='dropOffBranchNameUZ'
                                  id='dropOffBranchNameUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Branch Name')}
                                  value={dropOffBranchNameUZ}
                                  onChange={(e) => {
                                    setDropOffBranchNameUZ(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>
                                  {t('How Getting There? (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='dropOffGettingThereRU'
                                  id='dropOffGettingThereRU'
                                  className='form-control mb-2'
                                  placeholder={t('Getting There')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setDropOffGettingThereRU(e.target.value)
                                    removeError('dropOffGettingThereRU')
                                  }}
                                  value={dropOffGettingThereRU}
                                ></textarea>
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>
                                  {error[0].dropOffGettingThereRU}
                                </div>
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className=' fs-4 form-label'>
                                  {t('How Getting There? (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='dropOffGettingThereEN'
                                  id='dropOffGettingThereEN'
                                  className='form-control mb-2'
                                  placeholder={t('Getting There')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setDropOffGettingThereEN(e.target.value)
                                  }}
                                  value={dropOffGettingThereEN}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className=' fs-4 form-label'>
                                  {t('How Getting There? (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='dropOffGettingThereUZ'
                                  id='dropOffGettingThereUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Getting There')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setDropOffGettingThereUZ(e.target.value)
                                  }}
                                  value={dropOffGettingThereUZ}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>
                                  {t('Instruction (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='dropOffInstructionRU'
                                  id='dropOffInstructionRU'
                                  className='form-control mb-2'
                                  placeholder={t('Instruction')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setDropOffInstructionRU(e.target.value)
                                    removeError('dropOffInstructionRU')
                                  }}
                                  value={dropOffInstructionRU}
                                ></textarea>
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>
                                  {error[0].dropOffInstructionRU}
                                </div>
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className=' fs-4 form-label'>
                                  {t('Instruction (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='dropOffInstructionEN'
                                  id='dropOffInstructionEN'
                                  className='form-control mb-2'
                                  placeholder={t('Instruction')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setDropOffInstructionEN(e.target.value)
                                  }}
                                  value={dropOffInstructionEN}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className=' fs-4 form-label'>
                                  {t('Instruction (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='dropOffInstructionUZ'
                                  id='dropOffInstructionUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Instruction')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setDropOffInstructionUZ(e.target.value)
                                  }}
                                  value={dropOffInstructionUZ}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                          </>
                        )}
                        {primaryLanguage == 'Uzbek' && (
                          <>
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>
                                  {t('Branch Name (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='dropOffBranchNameUZ'
                                  id='dropOffBranchNameUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Branch Name')}
                                  value={dropOffBranchNameUZ}
                                  onChange={(e) => {
                                    setDropOffBranchNameUZ(e.target.value)
                                    removeError('dropOffBranchNameUZ')
                                  }}
                                />
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>
                                  {error[0].dropOffBranchNameUZ}
                                </div>
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className=' fs-4 form-label'>
                                  {t('Branch Name (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='dropOffBranchNameRU'
                                  id='dropOffBranchNameRU'
                                  className='form-control mb-2'
                                  placeholder={t('Branch Name')}
                                  value={dropOffBranchNameRU}
                                  onChange={(e) => {
                                    setDropOffBranchNameRU(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className=' fs-4 form-label'>
                                  {t('Branch Name (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='dropOffBranchNameEN'
                                  id='dropOffBranchNameEN'
                                  className='form-control mb-2'
                                  placeholder={t('Branch Name')}
                                  value={dropOffBranchNameEN}
                                  onChange={(e) => {
                                    setDropOffBranchNameEN(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>
                                  {t('How Getting There? (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='dropOffGettingThereUZ'
                                  id='dropOffGettingThereUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Getting There')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setDropOffGettingThereUZ(e.target.value)
                                    removeError('dropOffGettingThereRU')
                                  }}
                                  value={dropOffGettingThereUZ}
                                ></textarea>
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>
                                  {error[0].dropOffGettingThereUZ}
                                </div>
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className=' fs-4 form-label'>
                                  {t('How Getting There? (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='dropOffGettingThereRU'
                                  id='dropOffGettingThereRU'
                                  className='form-control mb-2'
                                  placeholder={t('Getting There')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setDropOffGettingThereRU(e.target.value)
                                  }}
                                  value={dropOffGettingThereRU}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className=' fs-4 form-label'>
                                  {t('How Getting There? (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='dropOffGettingThereEN'
                                  id='dropOffGettingThereEN'
                                  className='form-control mb-2'
                                  placeholder={t('Getting There')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setDropOffGettingThereEN(e.target.value)
                                  }}
                                  value={dropOffGettingThereEN}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>
                                  {t('Instruction (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='dropOffInstructionUZ'
                                  id='dropOffInstructionUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Instruction')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setDropOffInstructionUZ(e.target.value)
                                    removeError('dropOffInstructionUZ')
                                  }}
                                  value={dropOffInstructionUZ}
                                ></textarea>
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>
                                  {error[0].dropOffInstructionUZ}
                                </div>
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className=' fs-4 form-label'>
                                  {t('Instruction (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='dropOffInstructionRU'
                                  id='dropOffInstructionRU'
                                  className='form-control mb-2'
                                  placeholder={t('Instruction')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setDropOffInstructionRU(e.target.value)
                                  }}
                                  value={dropOffInstructionRU}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className=' fs-4 form-label'>
                                  {t('Instruction (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <textarea
                                  name='dropOffInstructionEN'
                                  id='dropOffInstructionEN'
                                  className='form-control mb-2'
                                  placeholder={t('Instruction')}
                                  cols={30}
                                  rows={4}
                                  onChange={(e) => {
                                    setDropOffInstructionEN(e.target.value)
                                  }}
                                  value={dropOffInstructionEN}
                                ></textarea>
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                          </>
                        )}
                        {/* <!--end::Input group--> */}
                        {/* <!--begin::Input group--> */}
                        <div className='row'>
                          <div className='col-lg-6 my-3'>
                            <label className='required fs-4 form-label'>
                              {t('Branch Address')}
                            </label>
                            <AutoComplete
                              name='location'
                              id='dropOffBranchAddress'
                              placeholder={t('Enter Location')}
                              value={dropOffBranchAddress}
                              onAddressSelect={(address: any) => {
                                setDropOffBranchAddress(address)
                                removeError('dropOffBranchAddress')
                              }}
                              longitude={(lng: any) => setDropOffBranchLongitude(lng)}
                              latitude={(lat: any) => setDropOffBranchLatitude(lat)}
                              country={(cnt: any) => setDropOffBranchCountry(cnt)}
                              state={(st: any) => setDropOffBranchState(st)}
                              city={(ct: any) => setDropOffBranchCity(ct)}
                            />
                            <div className='text-danger fw-bold'>
                              {error[0].dropOffBranchAddress}
                            </div>
                            <br />
                            <GoogleMapComponent2
                              latitude={dropOffBranchLatitude}
                              longitude={dropOffBranchLongitude}
                              onSelectLocation={(e: any) => setDropOffLocationObj(e)}
                            />
                          </div>
                          <div className='col-lg-6 my-3'>
                            {/* <!--begin::Label--> */}
                            <label id='dropOffContactNumber' className='fs-4 required form-label'>
                              {t('Contact Number')}
                            </label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <PhoneInput
                              inputClass='form-control form-control-solid w-100'
                              placeholder={t('Enter Mobile Number')}
                              enableSearch={true}
                              value={dropOffCountryCode + dropOffContactNumber}
                              country={'uz'}
                              onChange={handleDropOffChange}
                            />
                            {/* end::Form group */}
                            <div className='text-danger fw-bold'>
                              {error[0].dropOffContactNumber}
                            </div>
                            {/* <!--end::Input--> */}
                          </div>
                        </div>
                        {/* <!--end::Input group--> */}
                      </div>
                      <div className='card-body pt-7'>
                        <label className='required fs-4 form-label'>{t('Business Hours')}</label>
                        {dropOffOpeningHourData.map((dayData, dayIndex) => (
                          <div className='row' key={dayIndex}>
                            {/* <div className='col-lg-1'></div> */}
                            <div className='col-lg-2 my-3 d-flex justify-content-between align-items-center'>
                               <h5 className='mt-lg-5'>
                                {t(dayData.day.charAt(0).toUpperCase() + t(dayData.day).slice(1).toLowerCase())}
                              </h5>
                              {/* {dayData.timeSlot.length === 0 && (
                                <button
                                  className='btn btn-success mt-lg-10'
                                  onClick={() => addDropOffTimeField(dayIndex)}
                                >
                                  {t('Add')}
                                </button>
                              )} */}
                            </div>
                            <div className='col-lg-2 d-flex align-items-center'>
                              <div className='form-check form-check-custom form-check-solid form-check-success form-switch'>
                                <input
                                  className='form-check-input cursor-pointer'
                                  type='checkbox'
                                  id={`flexSwitchCheckDefault${dayIndex}`}
                                  checked={dayData.isOpen == '1'}
                                  onChange={() => toggleDayOpenDropOff(dayIndex)}
                                />
                                <label
                                  className='form-check-label text-gray-700 fw-bold ms-2'
                                  htmlFor={`flexSwitchCheckDefault${dayIndex}`}
                                  data-bs-toggle='tooltip'
                                  title={
                                    dayData.isOpen == '1' ? 'Currently Open' : 'Currently Closed'
                                  }
                                >
                                  {dayData.isOpen == '1' ? t('Open') : t('Closed')}
                                </label>
                              </div>
                            </div>
                            <div className='col-lg-8 my-3'>
                              {dayData.timeSlot.map((timeSlot, timeIndex) => (
                                <div className='row' key={timeIndex}>
                                  <div className='col col-lg-5'>
                                    <label className='fs-4 form-label required'>
                                      {t('Start Time')}
                                    </label>
                                    <Flatpickr
                                      data-enable-time
                                      value={moment(timeSlot.startTime, 'HH:mm:ss').format('HH:mm')}
                                      onChange={(date) => {
                                        const formattedTime = handleTimeChange(date)
                                        handleDropOffInputChange(dayIndex, timeIndex, {
                                          target: { name: 'startTime', value: formattedTime },
                                        })
                                      }}
                                      options={{
                                        enableTime: true, // Enable time selection
                                        noCalendar: true, // Hide the date picker, only show time
                                        dateFormat: 'H:i', // 24-hour format (H:i)
                                        time_24hr: true, // Enforces 24-hour format
                                        minuteIncrement: 15, // 15-minute increments in dropdown
                                        allowInput: false, // Allow typing custom times
                                      }}
                                      defaultValue={'00:00'}
                                      className='form-control mb-2'
                                    />
                                  </div>
                                  <div className='col col-lg-5'>
                                    <label className='fs-4 form-label required'>
                                      {t('End Time')}
                                    </label>
                                    <Flatpickr
                                      data-enable-time
                                      value={moment(timeSlot.endTime, 'HH:mm:ss').format('HH:mm')}
                                      onChange={(date) => {
                                        const formattedTime = handleTimeChange(date)
                                        handleDropOffInputChange(dayIndex, timeIndex, {
                                          target: { name: 'endTime', value: formattedTime },
                                        })
                                      }}
                                      options={{
                                        enableTime: true, // Enable time selection
                                        noCalendar: true, // Hide the date picker, only show time
                                        dateFormat: 'H:i', // 24-hour format (H:i)
                                        time_24hr: true, // Enforces 24-hour format
                                        minuteIncrement: 15, // 15-minute increments in dropdown
                                        allowInput: false, // Allow typing custom times
                                      }}
                                      defaultValue={'00:00'}
                                      className='form-control mb-2'
                                    />
                                  </div>
                                  <div className='col col-lg-2 d-flex justify-content-lg-start justify-content-end align-items-end'>
                                    {dayData.timeSlot.length > 1 ||
                                      (dayData.timeSlot.length === 1 && timeIndex === 0) ? (
                                      <button
                                        className='btn btn-danger mb-2'
                                        onClick={() => removeDropOffTimeField(dayIndex, timeIndex)}
                                      >
                                        X
                                      </button>
                                    ) : null}
                                    {timeIndex === dayData.timeSlot.length - 1 && (
                                      <button
                                        className='btn btn-success mb-2'
                                        onClick={() => addDropOffTimeField(dayIndex)}
                                      >
                                        +
                                      </button>
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='d-flex justify-content-end'>
                <button
                  type='button'
                  disabled={disable}
                  className='btn btn-primary'
                  onClick={addPickupOrDropoffApi}
                >
                  <span className='indicator-label'>{t('Next')}</span>
                  {loading && (
                    <span
                      className='spinner-border spinner-border-sm mx-2'
                      role='status'
                      aria-hidden='true'
                    ></span>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export { AddCarRentalPickupOrDropoffInfo }
